import { writable } from 'svelte/store';

interface WalletBalances {
	optimism: {
		ethBalance: string;
		usdcBalance: string;
		bloomBalance: string;
	};
	base: {
		ethBalance: string;
		usdcBalance: string;
	};
}

export const walletBalance = writable<WalletBalances>({
	optimism: {
		ethBalance: 'Loading...',
		usdcBalance: 'Loading...',
		bloomBalance: 'Loading...'
	},
	base: {
		ethBalance: 'Loading...',
		usdcBalance: 'Loading...'
	}
});
